<template>
  <div id="detail" class="detail">
    <!-- 头部区域 -->
    <div class="header-section">
      <div class="header-bg">
        <img src="@/assets/rightsDetails/self-operated/self-operatedbg.png" alt="头部背景" class="header-bg-img">
       
        <div class="advantages-section">
          <!-- 优势一 -->
          <div class="advantage-item advantage-item-1">
            <div class="advantage-header">
              <div class="advantage-title">
                <div>优势一: 精准守护、智能相伴</div>
              </div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-1">
                  为用户提供大救星健康监测APP、智能手表、血压计、心电记录仪及使用说明书。用户正确佩戴、使用，可实时掌握包括心率、血氧饱和度、血压、体温、睡眠质量及日常运动步数等在内的多项健康指标，定期自主进行心电检测服务。相关数据实时上传至大救星健康版App，依托大救星自研AI算法评估身体指标、给出健康分数，供用户随时掌握自身健康情况，并提供疾病趋势预报、疾病突发预警等服务。
                </div>
              </div>
            </div>
          </div>

          <!-- 优势二 -->
          <div class="advantage-item advantage-item-2">
            <div class="advantage-header">
              <div class="advantage-title">
                <div>优势二: 个性化健康档案、全生命<br>周期健康管理</div>
              </div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-2">
                  为用户构建个性化健康大模型，提供个性化的干预方案，如饮食、运动、睡眠等生活方式指导及中西医结合的全生命周期健康管理建议。结合健康数据量化展示定制方案，为用户打造科学、健康生活方式。配套服务覆盖家庭成员，为家人筑起全面的安全和健康防线。
                </div>
              </div>
            </div>
          </div>

          <!-- 优势三 -->
          <div class="advantage-item advantage-item-3">
            <div class="advantage-header">
              <div class="advantage-title">
                <div>优势三: 慢病健康呵护,专属私人医生</div></div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-3">
                  为每位用户配置私人医生，了解用户病史、生活习惯、健康状况、个人体重、身高等数据，为其制定个性化慢病康复管理方案。了解用户现在病情及用药，简化用药流程，定期提醒，调整用药种类及剂量，避免滥用。定期沟通随访，动态调整健康管理方案，及时发现问题，及时解决并优化服务方案。
                </div>
              </div>
            </div>
          </div>

          <!-- 优势四 -->
          <div class="advantage-item advantage-item-4">
            <div class="advantage-header">
              <div class="advantage-title"><div>优势四: "一键救援",有求必应</div></div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-4">
                  为用户提供覆盖全球的紧急救援服务，健康预警、救援救助无缝衔接。无论是身处家中或闹市，还是在旅途出差中，随时守护，提供紧急医疗转运、医疗送返、入院担保、医疗监护、绿通服务、安全管家服务、紧急联系人等。
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务权益说明部分 -->
        <div class="service-rights-section">
          <div class="service-rights-header">
            <div class="service-rights-title">服务权益说明</div>
          </div>

          <div class="service-list">
            <!-- 24小时健康监测服务 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('health-monitoring') }">
              <div class="service-item-header" @click="toggleItem('health-monitoring')">
                <div class="service-item-title">24小时健康监测服务</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('health-monitoring') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('health-monitoring')">
                <div class="service-item-text">
                  为用户提供智能监测手表、血压计、心电仪及使用说明书，用户正确佩戴，可提供24小时实时掌握包括心率、血氧饱和度、血压、体温、睡眠质量及日常运动步数等在内的多项健康指标，并提供心电监测服务。所有数据实时上传到大救星健康版App中，依托大救星AI算法模型计算身体健康分数，供用户随时掌握自身健康情况。（响应时效：7*24小时 权益次数：不限次）
                </div>
              </div>
            </div>

            <!-- 24小时疾病趋势预报服务 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('disease-trend') }">
              <div class="service-item-header" @click="toggleItem('disease-trend')">
                <div class="service-item-title">24小时疾病趋势预报服务</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('disease-trend') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('disease-trend')">
                <div class="service-item-text">
                  依托中国中医科学院科研成果--中医五藏态势监测技术及科学中医诊断，用户佩戴满24小时后显示"您有一份新的中医报告"，点击"查看报告"显示：心藏、肝藏、肾藏、脾藏评分结果并能查看其它体测数据。根据周期性身体指标趋势向用户提供调理或检查建议。（响应时效：7*24小时 权益次数：不限次）
                </div>
              </div>
            </div>

            <!-- 24小时疾病及时预警服务 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('disease-warning') }">
              <div class="service-item-header" @click="toggleItem('disease-warning')">
                <div class="service-item-title">24小时疾病及时预警服务</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('disease-warning') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('disease-warning')">
                <div class="service-item-text">
                  用户通过佩戴这款智能监测手表、血压计及心电仪进行日常监测，实时掌握自己的生命体征。一旦突发健康数据异常，手表会及时发出提醒，提示用户关注异常信息并采取必要的处置措施。（响应时效：7*24小时 权益次数：不限次）
                </div>
              </div>
            </div>

            <!-- 24小时私人医生服务 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('private-doctor-24h') }">
              <div class="service-item-header" @click="toggleItem('private-doctor-24h')">
                <div class="service-item-title">24小时私人医生服务</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('private-doctor-24h') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('private-doctor-24h')">
                <div class="service-item-text">
                    为每位用户配备专属心血管专科医生，24小时做好用户的日常健康管理服务。前期通过了解及掌握用户的身体状况及医疗病情，通过运动干预、生活方式干预、营养干预、心理干预、康复干预等，全年持续监测及干预，全方位为用户做好健康管理。（响应时效：7*24小时 权益次数：不限次）
                </div>
              </div>
            </div>

            <!-- 名医在线诊疗 -->
            <div class="service-item" :class="{ 'expanded': vipDoctorOnlineExpanded }">
              <div class="service-item-header" @click="toggleVipDoctorOnline">
                <div class="service-item-title">名医在线诊疗</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="vipDoctorOnlineExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="vipDoctorOnlineExpanded">
                <div class="service-item-text">
                  优选安贞医院心血管专科专家团队为用户提供预约制在线诊疗服务。（响应时效：3小时内 服务有效期：1-3天 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 名医预约挂号 -->
            <div class="service-item" :class="{ 'expanded': vipDoctorAppointmentExpanded }">
              <div class="service-item-header" @click="toggleVipDoctorAppointment">
                <div class="service-item-title">名医预约挂号</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="vipDoctorAppointmentExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="vipDoctorAppointmentExpanded">
                <div class="service-item-text">
                  为用户优选安贞医院心血管专科专家团队的门诊挂号服务。（响应时效：3小时内 服务有效期：3-5个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 名医住院安排 -->
            <div class="service-item" :class="{ 'expanded': vipDoctorHospitalizationExpanded }">
              <div class="service-item-header" @click="toggleVipDoctorHospitalization">
                <div class="service-item-title">名医住院安排</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="vipDoctorHospitalizationExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="vipDoctorHospitalizationExpanded">
                <div class="service-item-text">
                  为用户安排安贞医院心血管专科专家团队的住院安排服务。（响应时效：3小时内 服务有效期：5-7个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 紧急医疗转运 -->
            <div class="service-item" :class="{ 'expanded': emergencyTransferExpanded }">
              <div class="service-item-header" @click="toggleEmergencyTransfer">
                <div class="service-item-title">紧急医疗转运</div>
                <div class="service-item-availability">不限次, 限额50万元</div>
                <img 
                  :src="emergencyTransferExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="emergencyTransferExpanded">
                <div class="service-item-text">
                    当用户在出行期间遭受意外伤害或突发疾病等情形，若经大救星的救援医生及主治医生共同确定，用户所在医院医疗设施无法满足病情需要，需要转运到上级医院进一步救治。在当地医院开具转院证明的情形下，大救星在适宜的医疗监督下，通过适当的转运方式将用户运送至最近的且能够提供必要医疗设施的医疗场所。大救星承担转运费用，最高费用总额以服务限额为限。（响应时效：5分钟内 服务有效期：2-3天 权益次数：不限次，限额50万元）
                </div>
              </div>
            </div>

            <!-- 医疗送返 -->
            <div class="service-item" :class="{ 'expanded': medicalRepatriationExpanded }">
              <div class="service-item-header" @click="toggleMedicalRepatriation">
                <div class="service-item-title">医疗送返</div>
                <div class="service-item-availability">不限次, 限额50万元</div>
                <img 
                  :src="medicalRepatriationExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="medicalRepatriationExpanded">
                <div class="service-item-text">
                    当用户在出行期间遭受意外伤害或突发疾病等情形，在当地医院住院治疗一段时间，病情稳定或正常出院后，经大救星的救援医生及主治医生共同确认有医疗必要性需送返回到常住地的医疗机构或家中的情形下，大救星将安排适当的转运方式把用户送返回到常住地并承担转运费用，最高费用总额以服务限额为限。（响应时效：5分钟内 服务有效期：2-15天 权益次数：不限次，限额50万元）
                </div>
              </div>
            </div>

            <!-- 住院协助 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('hospitalization-assist') }">
              <div class="service-item-header" @click="toggleItem('hospitalization-assist')">
                <div class="service-item-title">住院协助</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('hospitalization-assist') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('hospitalization-assist')">
                <div class="service-item-text">
                    用户由于心血管疾病需住院治疗时，在获得用户提供的住院单后，为其安排主诊医生或优选推荐医生的住院床位，并在就诊过程中，予以协助。（响应时效：8小时内 服务有效期：7-10个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 门诊协助 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('outpatient-assist') }">
              <div class="service-item-header" @click="toggleItem('outpatient-assist')">
                <div class="service-item-title">门诊协助</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('outpatient-assist') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('outpatient-assist')">
                <div class="service-item-text">
                    用户由于心血管疾病有门诊就医需求时，根据用户的原有诊断，精确分诊，协助用户选择合适的医院及专家就诊（可指定医院科室、不指定医生）并安排挂号服务。（响应时效：8小时内 服务有效期：3-7个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 检查加急 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('expedited-examination') }">
              <div class="service-item-header" @click="toggleItem('expedited-examination')">
                <div class="service-item-title">检查加急</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('expedited-examination') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('expedited-examination')">
                <div class="service-item-text">
                    由于心血管疾病引起的需要检查项目加急，可根据用户的需求，协调安排各项检查加急，包括B超、CT、MRI、MRA、PET-CT等，确保检查尽早进行。（响应时效：8小时内 服务有效期：3-7个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 24小时在线医疗咨询服务 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('online-consultation') }">
              <div class="service-item-header" @click="toggleItem('online-consultation')">
                <div class="service-item-title">24小时在线医疗咨询服务</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('online-consultation') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('online-consultation')">
                <div class="service-item-text">
                  为用户提供24小时在线医疗咨询服务，由三甲医院主治及以上全科及专科医生通过电话、视频或图文方式为用户提供一对一的心血管疾病专科咨询、日常医学咨询、诊前就医指导、慢性病管理咨询、预防及日常保健咨询等，由专业分诊人员根据问诊需求匹配医生、不可指定医生。在线咨询完毕后，根据实际需求享受线上购药及递送药品等全流程服务。药品及递送费用都由用户承担。（响应时效：15秒内/单次通话20分钟内 权益次数：7*24小时不限次）
                </div>
              </div>
            </div>

            <!-- 入院陪护 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('admission-escort') }">
              <div class="service-item-header" @click="toggleItem('admission-escort')">
                <div class="service-item-title">入院陪护</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('admission-escort') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('admission-escort')">
                <div class="service-item-text">
                    安排护理顾问协助用户现场办理入院手续，包括但不限于排队缴费、协助医患沟通等，当天护理顾问提早10分钟到达医院，提早熟悉现场环境，现场陪护时间不超过4小时。（响应时效：3小时内 服务有效期：2个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 二次诊疗 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('second-opinion') }">
              <div class="service-item-header" @click="toggleItem('second-opinion')">
                <div class="service-item-title">二次诊疗</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('second-opinion') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('second-opinion')">
                <div class="service-item-text">
                  用户由于心血管疾病提出二次诊疗需求，协助用户收集各种必需的病情资料，由医学组全科医生根据用户的病情资料进行初审是否适用二诊（适用二诊情况：手术未定，多学科疾病，当前治疗方案下病情恶化等）。如初审通过后，3-7个工作日内将由工作人员代持用户相关病历资料向北上广TOP100三甲医院副主任及以上级别专家进行咨询，提供第二次专业医学意见书面报告，供用户及家属参考。（响应时效：8小时内 服务有效期：3-7个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 多学科会诊 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('multidisciplinary-consultation') }">
              <div class="service-item-header" @click="toggleItem('multidisciplinary-consultation')">
                <div class="service-item-title">多学科会诊</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('multidisciplinary-consultation') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('multidisciplinary-consultation')">
                <div class="service-item-text">
                    对于比较复杂的心血管重大疾病，如用户对疾病诊断有疑问时，可在7-10工作日内帮用户预约2-4个（含）科室多名权威专家（根据病情或用户要求确定）在非门诊时间进行视频面对面会诊。权威专家对用户的病情进行详细分析诊断，给出最适合的诊疗建议。（响应时效：8小时内 服务有效期：7-10个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 海外就医安排 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('overseas-medical') }">
              <div class="service-item-header" @click="toggleItem('overseas-medical')">
                <div class="service-item-title">海外就医安排</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('overseas-medical') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('overseas-medical')">
                <div class="service-item-text">
                  协助用户联系专业机构，7-14个工作日内由专业机构安排美国、德国、英国、日本海外顶级医院就诊，用户提供既往所有的病历资料，协助用户整理并传输病历资料，供专业机构安排海外就医诊疗。由此产生的第三方协调费用、签证费用、接送机费用、医疗费用、翻译费用等，需要用户承担。（响应时效：2个工作日 服务有效期：7-14个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 全球找药 -->
            <div class="service-item" :class="{ 'expanded': globalDrugSearchExpanded }">
              <div class="service-item-header" @click="toggleGlobalDrugSearch">
                <div class="service-item-title">全球找药</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="globalDrugSearchExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="globalDrugSearchExpanded">
                <div class="service-item-text">
                    如用户由于心血管疾病需申请全球找药服务，可持三甲级公立医疗机构开具7天内的国内已上市特药处方来申请服务，如国内特药无法满足治疗需求，经评估后可协调安排前往海南博鳌乐城国际医疗旅游先行区就诊，并协助对接特药资源。大救星可提供资源推介、协调安排等服务，如因此产生药费、就诊费用、出行费用等，需由用户自行承担。（响应时效：8小时内 服务有效期：7-10个工作日 权益次数：不限次）
                </div>
              </div>
            </div>

            <!-- 院后康复指导 -->
            <div class="service-item" :class="{ 'expanded': rehabilitationGuidanceExpanded }">
              <div class="service-item-header" @click="toggleRehabilitationGuidance">
                <div class="service-item-title">院后康复指导</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="rehabilitationGuidanceExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="rehabilitationGuidanceExpanded">
                <div class="service-item-text">
                    由具有专业医学背景的医生，与用户通过电话的方式进行一对一交流，提供专业康复指导，包括术后切口护理、锻炼方式时长、饮食、术后心理康复全方位的指导等。（响应时效：1小时内/需提前4小时发起服务请求 权益次数：不限次）
                </div>
              </div>
            </div>

            <!-- 医后随访 -->
            <div class="service-item" :class="{ 'expanded': medicalFollowUpExpanded }">
              <div class="service-item-header" @click="toggleMedicalFollowUp">
                <div class="service-item-title">医后随访</div>
                <div class="service-item-availability">1-5次</div>
                <img 
                  :src="medicalFollowUpExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="medicalFollowUpExpanded">
                <div class="service-item-text">
                    经心血管专家诊治后，相关健康管理专员提供一年1-5次电话关爱随访服务。（响应时效：30秒内/单次通话15分钟内/4小时内安排 权益次数：1-5次）
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 底部激活按钮 -->
    <div class="bottom-buttons" v-if="showActivateButton">
      <div class="button-container">
        <button class="activate-btn" @click="showActivateDialog">激活</button>
      </div>
    </div>
    
    <!-- 激活权益卡弹框 -->
    <div v-if="showActivateModal" class="activate-modal-overlay" @click="!isActivating && cancelActivate()">
      <div class="activate-modal" @click.stop>
        <div class="activate-modal-header">
          <div class="activate-modal-title">激活权益卡</div>
          <div class="activate-modal-close" @click="cancelActivate">
            <i class="el-icon-close"></i>
          </div>
        </div>
        
        <div class="activate-modal-content">
          <div class="activate-icon-wrapper">
            <div class="activate-icon">
              <i class="el-icon-tickets"></i>
            </div>
          </div>
          <div class="activate-tip">
            请输入实体卡权益码进行激活
          </div>
          <div class="activate-input-wrapper">
            <input
              v-model="cardCode"
              type="text"
              class="activate-input-field"
              placeholder="请输入实体卡权益码"
              :disabled="isActivating"
              maxlength="50"
            />
          </div>
        </div>
        
        <div class="activate-modal-footer">
          <button class="activate-cancel-btn" @click="cancelActivate" :disabled="isActivating">
            取消
          </button>
          <button 
            class="activate-confirm-btn" 
            @click="handleActivate"
            :disabled="isActivating || !cardCode || !cardCode.trim()"
          >
            <span v-if="!isActivating">确定</span>
            <span v-else class="loading-text">激活中...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// util
import { mapState, mapActions } from 'pinia';
import { useUserStore } from '@/stores/user';
import request from '@/utils/request';

/**
 * 泰和君安健康监测服务权益详情页面组件
 * 展示大救星"泰和君安"健康监测服务的权益说明
 */
export default {
  name: 'TaiheHealthMonitoring',
  computed: {
    ...mapState(useUserStore, ['userInfo'])
  },
  data() {
    return {
      /**
       * 展开的服务项列表
       * @type {Array<string>}
       */
      expandedItems: ['health-monitoring'], // 默认展开第一项
      /**
       * 名医在线诊疗是否展开
       * @type {boolean}
       */
      vipDoctorOnlineExpanded: false, // 名医在线诊疗默认收起
      /**
       * 名医预约挂号是否展开
       * @type {boolean}
       */
      vipDoctorAppointmentExpanded: false, // 名医预约挂号默认收起
      /**
       * 名医住院安排是否展开
       * @type {boolean}
       */
      vipDoctorHospitalizationExpanded: false, // 名医住院安排默认收起
      /**
       * 紧急医疗转运是否展开
       * @type {boolean}
       */
      emergencyTransferExpanded: false, // 紧急医疗转运默认收起
      /**
       * 医疗送返是否展开
       * @type {boolean}
       */
      medicalRepatriationExpanded: false, // 医疗送返默认收起
      /**
       * 全球找药是否展开
       * @type {boolean}
       */
      globalDrugSearchExpanded: false, // 全球找药默认收起
      /**
       * 院后康复指导是否展开
       * @type {boolean}
       */
      rehabilitationGuidanceExpanded: false, // 院后康复指导默认收起
      /**
       * 医后随访是否展开
       * @type {boolean}
       */
      medicalFollowUpExpanded: false, // 医后随访默认收起
      /**
       * 是否显示激活弹窗
       * @type {boolean}
       */
      showActivateModal: false,
      /**
       * 实体卡号
       * @type {string}
       */
      cardCode: '',
      /**
       * 是否正在激活中
       * @type {boolean}
       */
      isActivating: false,
      /**
       * 权益详情数据
       * @type {Object|null}
       */
      equityDetails: null,
      /**
       * 是否显示激活按钮
       * @type {boolean}
       */
      showActivateButton: true
    };
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px';
    }
    // 查询权益详情，判断是否已激活
    this.checkEquityStatus();
  },
  created() {
    document.title = '权益详情';
  },
  beforeCreate() {
    document
      .querySelector('#app')
      .setAttribute('style', 'background-color:#F2F3F5');
  },
  methods: {
    /**
     * 切换服务项的展开/折叠状态
     * @param {string} itemId - 服务项ID
     */
    toggleItem(itemId) {
      const index = this.expandedItems.indexOf(itemId);
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(itemId);
      }
    },
    /**
     * 切换名医在线诊疗的展开/折叠状态
     */
    toggleVipDoctorOnline() {
      this.vipDoctorOnlineExpanded = !this.vipDoctorOnlineExpanded;
    },
    /**
     * 切换名医预约挂号的展开/折叠状态
     */
    toggleVipDoctorAppointment() {
      this.vipDoctorAppointmentExpanded = !this.vipDoctorAppointmentExpanded;
    },
    /**
     * 切换名医住院安排的展开/折叠状态
     */
    toggleVipDoctorHospitalization() {
      this.vipDoctorHospitalizationExpanded = !this.vipDoctorHospitalizationExpanded;
    },
    /**
     * 切换紧急医疗转运的展开/折叠状态
     */
    toggleEmergencyTransfer() {
      this.emergencyTransferExpanded = !this.emergencyTransferExpanded;
    },
    /**
     * 切换医疗送返的展开/折叠状态
     */
    toggleMedicalRepatriation() {
      this.medicalRepatriationExpanded = !this.medicalRepatriationExpanded;
    },
    /**
     * 切换全球找药的展开/折叠状态
     */
    toggleGlobalDrugSearch() {
      this.globalDrugSearchExpanded = !this.globalDrugSearchExpanded;
    },
    /**
     * 切换院后康复指导的展开/折叠状态
     */
    toggleRehabilitationGuidance() {
      this.rehabilitationGuidanceExpanded = !this.rehabilitationGuidanceExpanded;
    },
    /**
     * 切换医后随访的展开/折叠状态
     */
    toggleMedicalFollowUp() {
      this.medicalFollowUpExpanded = !this.medicalFollowUpExpanded;
    },
    /**
     * 显示激活弹窗
     */
    showActivateDialog() {
      this.cardCode = '';
      this.showActivateModal = true;
    },
    /**
     * 取消激活
     */
    cancelActivate() {
      // 如果正在激活中，不允许关闭
      if (this.isActivating) {
        return;
      }
      this.showActivateModal = false;
      this.cardCode = '';
    },
    /**
     * 处理激活
     */
    async handleActivate() {
      // 验证实体卡号
      if (!this.cardCode || !this.cardCode.trim()) {
        this.$message('请输入实体卡权益码', 'warning');
        return;
      }
      
      // 防止重复提交
      if (this.isActivating) {
        return;
      }
      
      this.isActivating = true;
      
      try {
        // 获取API基础URL
        const apiUrl = window.SEVSRS || '';
        if (!apiUrl) {
          this.$message('系统配置错误，请联系管理员', 'error');
          this.isActivating = false;
          return;
        }
        
        // 调用激活接口
        const response = await request({
          url: apiUrl + '/equity/v2/activate',
          method: 'post',
          params: {
            code: this.cardCode.trim()
          },
          noLoading: false
        });
        
        // 处理响应
        if (response && response.data.code == '0') {
          // 激活成功
          this.$message('激活成功', 'success');
          this.showActivateModal = false;
          this.cardCode = '';
          
          // 延迟跳转到 mine 页面，并传递刷新参数，让用户看到成功提示
          setTimeout(() => {
            this.$router.push({
              path: '/mine',
              query: {
                refreshEquity: 'true'
              }
            });
          }, 1500);
        } else {
          // 激活失败
          const errorMsg = response.msg || '激活失败';
          this.$message(errorMsg, 'error');
        }
      } catch (error) {
        console.error('激活失败:', error);
        let errorMsg = '激活失败';
        if (error && error.response && error.response.data && error.response.data.msg) {
          errorMsg = error.response.data.msg;
        } else if (error && error.message) {
          errorMsg = error.message;
        }
        this.$message(errorMsg, 'error');
      } finally {
        this.isActivating = false;
      }
    },
    /**
     * 处理购买按钮点击
     * 跳转到微信小程序首页
     * 小程序 appid: wx062bf864dc3a9427
     * 参考 HealthQuanyi 页面的实现方式
     */
    handlePurchase() {
      const appId = 'wx062bf864dc3a9427';
      const path = 'pages/home/home'; // 小程序首页路径
      
      // 构建小程序配置对象
      const miniProgramConfig = {
        appId: appId,
        path: path,
        originalId: '', // 如果需要使用开放标签，需要提供 originalId
        name: '小程序首页'
      };
      
      console.log('开始跳转微信小程序，配置信息:', miniProgramConfig);
      
      // 环境检测
      const userAgent = navigator.userAgent.toLowerCase();
      const isWeChat = userAgent.includes('micromessenger');
      
      console.log('环境检测:', { isWeChat });
      
      if (isWeChat) {
        // 在微信内，优先使用 wx.navigateToMiniProgram（不需要 originalId）
        this.launchInWeChatWithAPI(appId, path, miniProgramConfig);
      } else {
        // 在微信外，使用明文URL Scheme
        this.launchWithPlainTextScheme(appId, path);
      }
    },
    
    /**
     * 在微信内使用 wx.navigateToMiniProgram API 跳转（优先方案）
     * @param {String} appId - 小程序 appId
     * @param {String} path - 小程序页面路径
     * @param {Object} config - 小程序配置
     */
    launchInWeChatWithAPI(appId, path, config) {
      console.log('在微信内使用 wx.navigateToMiniProgram API 跳转');
      
      // 检查微信JS-SDK是否加载
      if (typeof wx === 'undefined') {
        console.error('微信JS-SDK未加载');
        this.fallbackLaunch(config);
        return;
      }
      
      // 使用 wx.navigateToMiniProgram 跳转（不需要 originalId）
      wx.navigateToMiniProgram({
        appId: appId,
        path: path,
        envVersion: 'release', // release-正式版, trial-体验版, develop-开发版
        success: (res) => {
          console.log('跳转小程序成功', res);
          this.$message && this.$message.success('正在跳转到小程序...');
        },
        fail: (err) => {
          console.error('wx.navigateToMiniProgram 失败:', err);
          // 如果 wx.navigateToMiniProgram 失败，尝试使用开放标签（需要 originalId）
          // 如果没有 originalId，则使用 URL Scheme
          if (config.originalId) {
            this.launchInWeChatWithOpenTag(config);
          } else {
            this.launchWithPlainTextScheme(appId, path);
          }
        }
      });
    },
    
    /**
     * 在微信内使用开放标签跳转（备用方案，需要 originalId）
     * @param {Object} config - 小程序配置
     */
    launchInWeChatWithOpenTag(config) {
      console.log('在微信内使用开放标签跳转');
      
      // 获取用户手机号并构建带参数的页面路径
      const userPhone = this.userInfo.userPhone || '';
      const pathWithParams = this.buildPathWithUserPhone(config.path, userPhone);
      console.log('用户手机号:', userPhone);
      console.log('页面路径:', pathWithParams);
      
      // 创建wx-open-launch-weapp标签
      const wxTag = document.createElement('wx-open-launch-weapp');
      wxTag.setAttribute('username', config.originalId);
      wxTag.setAttribute('path', pathWithParams);
      
      // 创建按钮
      const button = document.createElement('button');
      button.textContent = '正在跳转到小程序...';
      button.style.cssText = `
        width: 100%;
        height: 40px;
        background: #07c160;
        color: white;
        border: none;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
      `;
      
      wxTag.appendChild(button);
      document.body.appendChild(wxTag);
      
      // 监听事件
      wxTag.addEventListener('launch', (e) => {
        console.log('小程序启动成功');
        this.$message && this.$message.success('正在跳转到小程序...');
      });
      
      wxTag.addEventListener('error', (e) => {
        console.error('小程序启动失败:', e.detail);
        this.fallbackLaunch(config);
      });
      
      // 自动点击
      setTimeout(() => button.click(), 100);
      
      // 清理
      setTimeout(() => {
        if (document.body.contains(wxTag)) {
          document.body.removeChild(wxTag);
        }
      }, 5000);
    },
    
    /**
     * 构建带用户手机号的页面路径
     * @param {String} basePath - 基础页面路径
     * @param {String} userPhone - 用户手机号
     * @returns {String} 带参数的页面路径
     */
    buildPathWithUserPhone(basePath, userPhone) {
      if (!userPhone) {
        return basePath;
      }
      
      // 构建查询参数
      const params = new URLSearchParams({
        userPhone: userPhone
      });
      
      // 如果有参数，添加到路径中
      const queryString = params.toString();
      return queryString ? `${basePath}?${queryString}` : basePath;
    },
    
    /**
     * 使用明文URL Scheme跳转（微信外使用）
     * @param {String} appId - 小程序 appId
     * @param {String} path - 小程序页面路径
     */
    launchWithPlainTextScheme(appId, path) {
      console.log('使用明文URL Scheme跳转');
      
      // 获取用户手机号
      const userPhone = this.userInfo.userPhone || '';
      
      // 生成明文URL Scheme
      // 格式：weixin://dl/business/?appid=APPID&path=PATH&query=PARAMS
      let plainTextScheme = `weixin://dl/business/?appid=${appId}&path=${path}`;
      if (userPhone) {
        plainTextScheme += `&query=userPhone%3D${userPhone}`;
      }
      
      console.log('明文URL Scheme:', plainTextScheme);
      
      // 检测是否为 iOS 系统
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      console.log('系统检测:', { isIOS });
      
      // iOS 系统使用 a 标签点击方式跳转
      if (isIOS) {
        this.launchWithIOS(plainTextScheme);
      } else {
        // Android 系统使用 window.location.href 方式
        this.launchWithAndroid(plainTextScheme);
      }
    },
    
    /**
     * iOS 系统跳转方式
     * @param {String} scheme - URL Scheme
     */
    launchWithIOS(scheme) {
      console.log('iOS系统：使用a标签方式跳转');
      
      try {
        // 创建隐藏的 a 标签
        const link = document.createElement('a');
        link.href = scheme;
        link.style.display = 'none';
        document.body.appendChild(link);
        
        // 触发点击
        link.click();
        
        // 显示提示
        this.$message && this.$message.success('正在打开微信小程序...');
        
        // 延迟清理
        setTimeout(() => {
          if (document.body.contains(link)) {
            document.body.removeChild(link);
          }
        }, 1000);
        
        // iOS 备用方案：如果 a 标签不生效，尝试 iframe 方式
        setTimeout(() => {
          console.log('iOS备用方案：使用iframe方式');
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = scheme;
          document.body.appendChild(iframe);
          
          setTimeout(() => {
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
          }, 2000);
        }, 500);
        
      } catch (error) {
        console.error('iOS跳转失败:', error);
        this.$message && this.$message.error('打开微信小程序失败，请确保已安装微信');
      }
    },
    
    /**
     * Android 系统跳转方式
     * @param {String} scheme - URL Scheme
     */
    launchWithAndroid(scheme) {
      console.log('Android系统：使用window.location方式跳转');
      
      try {
        window.location.href = scheme;
        this.$message && this.$message.success('正在打开微信小程序...');
      } catch (error) {
        console.error('Android跳转失败:', error);
        this.$message && this.$message.error('打开微信小程序失败，请确保已安装微信');
      }
    },
    
    /**
     * 跳转失败的备用方案
     * @param {Object} config - 小程序配置
     */
    fallbackLaunch(config) {
      console.log('Scheme打开失败，使用备选方案:', config);
      
      // 备选方案：引导用户手动打开或使用其他方法
      this.$alert && this.$alert(`无法直接唤起小程序，请手动打开微信搜索小程序：${config.name}`, '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      });
    },
    /**
     * 检查权益状态，判断是否已激活
     * 如果接口返回有 productId，说明已激活，隐藏激活按钮
     */
    async checkEquityStatus() {
      try {
        const res = await this.queryHealthQuanyi();
        // 检查响应是否成功且有数据
        if (res && res.code == '1000' && res.data && res.data.length > 0) {
          this.equityDetails = res.data[0];
          // 如果有 productId，说明已激活，隐藏激活按钮
          if (this.equityDetails.productId) {
            this.showActivateButton = false;
          } else {
            this.showActivateButton = true;
          }
        } else {
          // 没有数据，显示激活按钮
          this.showActivateButton = true;
        }
      } catch (error) {
        // 接口调用失败，显示激活按钮
        console.error('查询权益详情失败:', error);
        this.showActivateButton = true;
      }
    },
    ...mapActions(useUserStore, ['queryHealthQuanyi'])
  }
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: auto;
  background-color: #A0EDD2;
  overflow-x: hidden;
  box-sizing: border-box;
  padding-bottom: 80px; /* 为底部按钮留出空间 */
}

/* 头部区域 */
.header-section {
  width: 100%;
  position: relative;
}

.header-bg {
  width: 100%;
  position: relative;
}

.header-bg-img {
  width: 100%;
  display: block;
  position: relative;
  z-index: 1;
}

/* 服务概述部分 */
.service-overview-section {
  width: 100%;
  padding: 13px 10px 0px 13px;
  position: relative;
  z-index: 2;
}

.service-overview-box {
  width: 100%;
  margin-bottom: 13px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: #E8F5E9;
  border-radius: 8px;
  padding: 16px;
}

.service-overview-text {
  color: #333;
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
}

/* 优势部分 */
.advantages-section {
  width: 100%;
  padding: 0 10px 0px 13px;
  position: relative;
  z-index: 2;
  margin-top: -75px;
}

.advantage-item {
  width: 100%;
  margin-bottom: 13px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background-color: transparent;
}

.advantage-header {
  width: 100%;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}

.advantage-title {
  position: relative;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  padding: 5px 30px;
  padding-bottom: 0;
  margin: 0;
  z-index: 10;
  border-radius: 6px 6px 0 0;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  /* 背景图从上到下整个盒子展示 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
}

/**
 * 优势一标题样式
 * 添加背景图
 */
.advantage-item-1 .advantage-title {
  background-image: url('~@/assets/rightsDetails/self-operated/SelfoperatedPlan1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
  height: 55px;
}

/**
 * 优势二标题样式
 * 添加背景图
 */
.advantage-item-2 .advantage-title {
  background-image: url('~@/assets/rightsDetails/self-operated/SelfoperatedPlan2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
  height: 76px;
}

/**
 * 优势三标题样式
 * 添加背景图
 */
.advantage-item-3 .advantage-title {
  background-image: url('~@/assets/rightsDetails/self-operated/SelfoperatedPlan34.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
  height: 55px;
}

/**
 * 优势四标题样式
 * 添加背景图
 */
.advantage-item-4 .advantage-title {
  background-image: url('~@/assets/rightsDetails/self-operated/SelfoperatedPlan34.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
  height: 55px;
}
.advantage-title div {
  margin-top: -15px;
}
.advantage-content {
  padding: 0 13px 16px;
  margin: 0;
  border-radius: 0 0 6px 6px;
  position: relative;
  z-index: 1;
  background-color: #fff;
  margin-top: -12px;
}
.advantage-item-1 .advantage-content {
  margin-top: -12px;
}
.advantage-item-2 .advantage-content {
    margin-top: -18px;
  }
  .advantage-item-3 .advantage-content {
    margin-top: -14px;
  }
  .advantage-item-4 .advantage-content {
    margin-top: -14px;
  }
.advantage-text {
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  text-align: justify;
  padding: 10px;
}

/* 服务权益说明部分 */
.service-rights-section {
  width: 100%;
  padding: 16px 0;
  position: relative;
  z-index: 1;
}

.service-rights-header {
  width: 100%;
  position: relative;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10%;
}

.service-rights-title {
  color: #00B164;
  font-size: 24px;
  font-weight: bold;
  margin: 0 10px;
  white-space: nowrap;
  text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #fff;
}

.service-list {
  width: 100%;
  padding: 0 8px;
  position: relative;
  z-index: 1;
}

.service-item {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.service-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px;
  cursor: pointer;
  background-color: #fff;
  transition: background-color 0.3s;
}

.service-item-header:active {
  background-color: #f5f5f5;
}

.service-item-title {
  flex: 1;
  color: #00AB64;
  font-size: 16px;
  font-weight: 500;
  margin-right: 6px;
}

.service-item-availability {
  color: #333333;
  font-size: 15px;
  margin-right: 6px;
  white-space: nowrap;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s;
}

.service-item.expanded .arrow-icon {
  transform: rotate(180deg);
}

.service-item-content {
  padding: 0 13px 13px;
  background-color: #fff;
}

.service-item-text {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  text-align: justify;
  background-color: #EDFEF8;
  border-radius: 5px;
  padding: 10px;
}

.service-sub-item {
  margin-bottom: 15px;
}

.service-sub-item:last-child {
  margin-bottom: 0;
}

.service-sub-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  gap: 8px;
}

.service-sub-title-text {
  color: #FE7D1E;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
}

.service-sub-title-icon-left,
.service-sub-title-icon-right {
  width: auto;
  height: 20px;
  display: block;
  flex-shrink: 0;
}

.service-sub-text {
  color: #666;
  font-size: 11px;
  line-height: 1.6;
  text-align: justify;
}

/* 底部按钮区域 */
.bottom-buttons {
  width: 100%;
  padding: 16px;
  background-color: #A0EDD2;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.button-container {
  display: flex;
  gap: 12px;
  width: 100%;
}

.activate-btn,
.purchase-btn {
  flex: 1;
  height: 48px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.activate-btn {
  background: linear-gradient(135deg, #00C275 0%, #00AB64 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
}

.activate-btn:active {
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(0, 194, 117, 0.3);
}

.purchase-btn {
  background: linear-gradient(135deg, #FF7D1E 0%, #FF6B00 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(255, 125, 30, 0.3);
}

.purchase-btn:active {
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(255, 125, 30, 0.3);
}

/* 激活权益卡弹框样式 */
.activate-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.activate-modal {
  width: 85%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
  position: relative;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.activate-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: linear-gradient(135deg, #00C275 0%, #00AB64 100%);
  position: relative;
}

.activate-modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}

.activate-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.activate-modal-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.activate-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.activate-modal-close:active {
  transform: scale(0.95);
}

.activate-modal-close i {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
}

.activate-modal-content {
  padding: 32px 24px 24px;
}

.activate-icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.activate-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.2);
}

.activate-icon i {
  font-size: 32px;
  color: #00C275;
}

.activate-tip {
  color: #666666;
  font-size: 14px;
  text-align: center;
  margin-bottom: 24px;
  line-height: 1.6;
}

.activate-input-wrapper {
  margin-bottom: 8px;
}

.activate-input-field {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  font-size: 16px;
  color: #333333;
  background: #FAFAFA;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.activate-input-field:focus {
  outline: none;
  border-color: #00C275;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 194, 117, 0.1);
}

.activate-input-field:disabled {
  background: #F5F5F5;
  color: #999999;
  cursor: not-allowed;
}

.activate-input-field::placeholder {
  color: #CCCCCC;
}

.activate-modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 24px 24px;
  border-top: 1px solid #F0F0F0;
}

.activate-cancel-btn,
.activate-confirm-btn {
  flex: 1;
  height: 48px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.5px;
}

.activate-cancel-btn {
  background: #F5F5F5;
  color: #666666;
  border: 1px solid #E5E5E5;
}

.activate-cancel-btn:hover:not(:disabled) {
  background: #EEEEEE;
  transform: translateY(-1px);
}

.activate-cancel-btn:active:not(:disabled) {
  transform: translateY(0);
}

.activate-cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.activate-confirm-btn {
  background: linear-gradient(135deg, #00C275 0%, #00AB64 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.3);
}

.activate-confirm-btn:hover:not(:disabled) {
  box-shadow: 0 6px 16px rgba(0, 194, 117, 0.4);
  transform: translateY(-2px);
}

.activate-confirm-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
}

.activate-confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.loading-text {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.loading-text::before {
  content: '';
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 响应式调整 */
@media (max-width: 375px) {
  .activate-btn {
    font-size: 14px;
    height: 44px;
  }
  
  .bottom-buttons {
    padding: 12px;
  }
  
  .button-container {
    gap: 10px;
  }
  
  .activate-modal {
    width: 90%;
  }
  
  .activate-modal-content {
    padding: 24px 20px 20px;
  }
  
  .activate-modal-header {
    padding: 16px 20px;
  }
  
  .activate-modal-footer {
    padding: 12px 20px 20px;
  }
  
  .activate-cancel-btn,
  .activate-confirm-btn {
    height: 44px;
    font-size: 15px;
  }
}

</style>




// WEBPACK FOOTER //
// src/views/detailsH5/taiheHealthMonitoring.vue